module.exports = __webpack_public_path__ + "static/media/icono_karaoke.112a87c3.svg";